import React from 'react';

import PropTypes from 'prop-types';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

import S from '../styles';

const defaultMaskOptions = {
  prefix: 'R$ ',
  suffix: '',
  includeThousandsSeparator: true,
  thousandsSeparatorSymbol: '.',
  allowDecimal: true,
  decimalSymbol: ',',
  decimalLimit: 2,
  allowNegative: true,
  allowLeadingZeroes: false,
};

function InputCurrency({ inputRef, value, ...inputProps }) {
  const currencyMask = createNumberMask({ ...defaultMaskOptions });

  if (value) {
    return (
      <S.Input
        autoFocus
        ref={inputRef}
        defaultValue={String(value).replace('.', ',')}
        mask={currencyMask}
        {...inputProps}
      />
    );
  }
  return <S.Input autoFocus ref={inputRef} mask={false} {...inputProps} />;
}

InputCurrency.defaultProps = {
  inputRef: null,
  value: '',
};

InputCurrency.propTypes = {
  inputRef: PropTypes.objectOf(PropTypes.any),
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default InputCurrency;
